"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _luxon = require("luxon");

var _max = _interopRequireDefault(require("lodash/max"));

var _colors = require("./colors");

var _Styles = require("./Styles");

var _chartUtils = require("../../chartUtils");

var _helpers = require("../../helpers");

var _chartDataTypes = require("../../constants/chartDataTypes");

var _CustomerInteraction = _interopRequireDefault(require("./CustomerInteraction"));

var _CustomerDisplay = _interopRequireDefault(require("./CustomerDisplay"));

var _ChartTick = _interopRequireDefault(require("./ChartTick"));

var _ScrollableXYPlot = _interopRequireDefault(require("./ScrollableXYPlot"));

var _CustomerHint = _interopRequireDefault(require("./CustomerHint"));

var _CustomerLegend = _interopRequireDefault(require("./CustomerLegend"));

var _CustomerDailyChart$p, _CustomerDailyChart$d;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CustomerDailyChart = function CustomerDailyChart(_ref) {
  var chartType = _ref.chartType,
      endDate = _ref.endDate,
      siteProductionDailyReadings = _ref.siteProductionDailyReadings,
      startDate = _ref.startDate,
      timeZone = _ref.timeZone,
      weather = _ref.weather,
      desktopWidth = _ref.desktopWidth,
      mobileWidth = _ref.mobileWidth,
      enabledDataTypes = _ref.enabledDataTypes,
      children = _ref.children,
      batteryDailyReadings = _ref.batteryDailyReadings;
  var hasProduction = enabledDataTypes.indexOf(_chartDataTypes.PRODUCTION) > -1;
  var hasConsumption = enabledDataTypes.indexOf(_chartDataTypes.CONSUMPTION) > -1;
  var hasBattery = enabledDataTypes.indexOf(_chartDataTypes.BATTERY) > -1;

  var luxonStartDate = _luxon.DateTime.fromISO(startDate, {
    zone: timeZone
  });

  var luxonEndDate = _luxon.DateTime.fromISO(endDate, {
    zone: timeZone
  });

  var readingDictionary = siteProductionDailyReadings.reduce(function (dictionary, reading) {
    var id = _luxon.DateTime.fromISO(reading.readingEndTimeLocal, {
      zone: timeZone
    }).toISODate();

    dictionary[id] = reading;
    return dictionary;
  }, {});
  var batteryDictionary = !hasBattery ? {} : batteryDailyReadings.reduce(function (dictionary, reading) {
    var id = _luxon.DateTime.fromISO(reading.readingEndTimeLocal, {
      zone: timeZone
    }).toISODate();

    dictionary[id] = reading;
    return dictionary;
  }, {});
  var weatherDictionary = weather.data.reduce(function (dictionary, d) {
    var id = _luxon.DateTime.fromISO(d.date, {
      zone: timeZone
    }).toISODate();

    dictionary[id] = d;
    return dictionary;
  }, {});
  var datesBetween = (0, _helpers.getDatesBetween)({
    startDate: luxonStartDate,
    endDate: luxonEndDate
  }, {
    hour: 23,
    minute: 59,
    second: 59
  }, 'days');
  var productionCoordinates = [];
  var consumptionCoordinates = [];
  var batteryCoordinates = [];
  var groupedCoordinates = [];
  datesBetween.forEach(function (dt) {
    var isoDate = dt.toISODate();
    var productionY = hasProduction && readingDictionary[isoDate] && (0, _chartUtils.isNumeric)(readingDictionary[isoDate].deliveredKwh) ? Number(readingDictionary[isoDate].deliveredKwh) : 0;
    var productionCoordinate = {
      x: isoDate,
      y: productionY,
      y0: 0
    };
    var consumptionY = 0;

    if (hasConsumption && readingDictionary[isoDate] && (0, _chartUtils.isNumeric)(readingDictionary[isoDate].estimatedConsumptionKwh)) {
      consumptionY = Number(readingDictionary[isoDate].estimatedConsumptionKwh);
    } else if (hasConsumption && readingDictionary[isoDate] && (0, _chartUtils.isNumeric)(readingDictionary[isoDate].consumptionKwh)) {
      consumptionY = Number(readingDictionary[isoDate].consumptionKwh);
    }

    var batteryY = 0;

    if (hasBattery && batteryDictionary[isoDate] && (0, _chartUtils.isNumeric)(batteryDictionary[isoDate].energyDischargedKwh)) {
      batteryY = Number(batteryDictionary[isoDate].energyDischargedKwh);
    }

    var consumptionCoordinate = {
      x: isoDate,
      y: consumptionY,
      y0: 0
    };
    var batteryCoordinate = {
      x: isoDate,
      y: batteryY,
      y0: 0
    };
    var groupedCoordinate = {
      x: isoDate,
      y: 0,
      y0: 0,
      coordinates: []
    };

    if (hasConsumption) {
      groupedCoordinate.coordinates.push(_objectSpread(_objectSpread({}, consumptionCoordinate), {}, {
        color: _colors.CUSTOMER_CONSUMPTION,
        name: 'Consumption'
      }));
    }

    if (hasProduction) {
      groupedCoordinate.coordinates.push(_objectSpread(_objectSpread({}, productionCoordinate), {}, {
        color: _colors.START_GRADIENT,
        name: 'Production'
      }));
    }

    if (hasBattery) {
      groupedCoordinate.coordinates.push(_objectSpread(_objectSpread({}, batteryCoordinate), {}, {
        color: _colors.BATTERY,
        name: 'Total Discharge'
      }));
    }

    productionCoordinates.push(productionCoordinate);
    consumptionCoordinates.push(consumptionCoordinate);
    batteryCoordinates.push(batteryCoordinate);
    groupedCoordinates.push(groupedCoordinate);
  });
  var hasNoData = Object.keys(readingDictionary).length === 0 && Object.keys(batteryDictionary).length === 0;
  var maxValue = (0, _max["default"])(productionCoordinates.concat(consumptionCoordinates, batteryCoordinates).map(function (c) {
    return c.y;
  }));
  var roundedMaxValue = Math.max(Math.ceil(maxValue / 5) * 5, 5);
  var tickValues = (0, _helpers.getTickValuesFromMax)(roundedMaxValue);
  var widths = {
    mobile: mobileWidth,
    desktop: desktopWidth
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ScrollableXYPlot["default"], {
    isBattery: false,
    hasNoData: hasNoData,
    roundedMaxValue: roundedMaxValue,
    tickValues: tickValues,
    widths: widths
  }, /*#__PURE__*/_react["default"].createElement(_CustomerDisplay["default"], {
    roundedMaxValue: roundedMaxValue,
    tickValues: tickValues,
    productionCoordinates: productionCoordinates,
    consumptionCoordinates: consumptionCoordinates,
    batteryCoordinates: batteryCoordinates,
    weatherDictionary: weatherDictionary,
    chartType: chartType,
    enabledDataTypes: enabledDataTypes,
    hasNoData: hasNoData,
    widths: widths,
    renderXAxisTick: function renderXAxisTick(isoDate) {
      var dt = _luxon.DateTime.fromISO(isoDate, {
        zone: timeZone
      });

      var icon = weatherDictionary[isoDate] ? weatherDictionary[isoDate].icon : null;
      return /*#__PURE__*/_react["default"].createElement(_ChartTick["default"], {
        fontSize: "12px",
        fill: _colors.WEATHER_ICON_COLOR,
        label: dt.toFormat('M/d'),
        icon: icon
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_CustomerInteraction["default"], {
    chartType: chartType,
    timeZone: timeZone,
    widths: widths,
    tickValues: tickValues,
    groupedCoordinates: groupedCoordinates,
    roundedMaxValue: roundedMaxValue,
    renderHint: function renderHint(selectedCoordinate) {
      return /*#__PURE__*/_react["default"].createElement(_CustomerHint["default"], {
        selectedCoordinate: selectedCoordinate,
        zone: timeZone,
        dateFormat: "LLLL d"
      });
    }
  }), hasNoData && children && /*#__PURE__*/_react["default"].createElement(_Styles.FillAvailableSpace, null, children)), /*#__PURE__*/_react["default"].createElement(_CustomerLegend["default"], {
    enabledDataTypes: enabledDataTypes
  }));
};

CustomerDailyChart.propTypes = (_CustomerDailyChart$p = {
  chartType: _propTypes["default"].oneOf(['Line', 'Bar']),
  children: _propTypes["default"].node,
  endDate: _propTypes["default"].string.isRequired,
  ptoDateISO: _propTypes["default"].string.isRequired,
  renderHint: _propTypes["default"].func,
  startDate: _propTypes["default"].string.isRequired,
  siteProductionDailyReadings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    deliveredKwh: _propTypes["default"].string,
    readingEndTimeLocal: _propTypes["default"].string
  })),
  timeZone: _propTypes["default"].string.isRequired,
  weather: _propTypes["default"].shape({
    data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      date: _propTypes["default"].string.isRequired,
      icon: _propTypes["default"].string.isRequired,
      temperature: _propTypes["default"].number.isRequired
    }))
  }),
  desktopWidth: _propTypes["default"].string,
  mobileWidth: _propTypes["default"].string,
  enabledDataTypes: _propTypes["default"].arrayOf(_propTypes["default"].oneOf([_chartDataTypes.PRODUCTION, _chartDataTypes.CONSUMPTION]))
}, _defineProperty(_CustomerDailyChart$p, "children", _propTypes["default"].node), _defineProperty(_CustomerDailyChart$p, "batteryDailyReadings", _propTypes["default"].arrayOf(_propTypes["default"].shape({
  energyDischargedKwh: _propTypes["default"].string,
  readingEndTimeLocal: _propTypes["default"].string
}))), _CustomerDailyChart$p);
CustomerDailyChart.defaultProps = (_CustomerDailyChart$d = {
  chartType: 'Bar',
  children: undefined,
  renderHint: undefined,
  siteProductionDailyReadings: [],
  weather: {
    data: []
  },
  desktopWidth: '100%',
  mobileWidth: '1200px',
  enabledDataTypes: [_chartDataTypes.PRODUCTION]
}, _defineProperty(_CustomerDailyChart$d, "children", null), _defineProperty(_CustomerDailyChart$d, "batteryDailyReadings", []), _CustomerDailyChart$d);
var _default = CustomerDailyChart;
exports["default"] = _default;